import { styled } from '@mui/material/styles';
import { useTheme, Typography } from '@mui/material';
import { useState } from 'react';
import { useDeal } from '../../../providers/DealProvider';
import { DealForm } from '../DealForm/DealForm';
import { useModalState } from '../../../../../components/Modal/ModalContext';
import { Circle, StepNumber } from './Circle';
import { DuplicateDealInfo } from './DuplicateDealInfo';

const Wrapper = styled('div')<{ isActive: boolean }>`
  background-color: ${({ theme, isActive }) =>
    isActive ? theme.colors.primary[5] : theme.colors.neutral[2]};
  padding: 24px;
`;

const Heading = styled('div')`
  display: flex;
  align-items: center;
  gap: 1rem;
  width: 100%;
  cursor: pointer;
`;

const CaptionWrapper = styled('div')`
  margin: 13px 0;
`;

export const DealSection = () => {
  const { colors } = useTheme();
  const { activeStep, duplicateDeal } = useDeal();

  const { onCloseModal } = useModalState();
  const [proceed, setProceed] = useState(!duplicateDeal);

  return (
    <Wrapper isActive={activeStep === 2}>
      <Heading>
        <Circle isOpen={activeStep === 2} isChecked={false}>
          <StepNumber isOpen={activeStep === 2}>{2}</StepNumber>
        </Circle>
        <Typography variant={'subtitle1'} color={colors.primary[90]}>
          Deal Details
        </Typography>
      </Heading>
      <CaptionWrapper>
        <Typography variant='caption' color={colors.neutral[50]}>
          Add details to the deal
        </Typography>
      </CaptionWrapper>
      {Boolean(duplicateDeal) && activeStep === 2 && !proceed && (
        <DuplicateDealInfo deal={duplicateDeal!} onCancel={onCloseModal} onConfirm={() => setProceed(true)} />
      )}
      {activeStep === 2 && proceed && <DealForm />}
    </Wrapper>
  );
};
